import PagedFilterAndSortedRequest from "@/store/entities/page-request";

export default class GetEntityChangeInput extends PagedFilterAndSortedRequest {
    startDate: Date;
    endDate: Date;
    userName: string;
    entityTypeFullName: string;
    entityId: string;
}
